"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipWrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../../styles");
var ChipWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  padding: 0 0.5rem;\n  border-radius: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  svg {\n    margin-left: 0.5rem;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  padding: 0 0.5rem;\n  border-radius: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  svg {\n    margin-left: 0.5rem;\n  }\n"])), styles_1.theme.borderRadius.normal, styles_1.theme.colors.paleBlue);
exports.ChipWrapper = ChipWrapper;
var templateObject_1;
//# sourceMappingURL=Chip.styled.js.map